module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/396.c12d2949.png";